module.exports = __webpack_public_path__ + "static/lesson_9-eba7de0507810334bbdeca75cfcf3daf.png";